import React, { memo } from 'react';
import PropTypes from 'prop-types';
import lang from 'hh-shared/dist/language/services/languageService';
import icons from 'hh-shared/dist/consts/icons';
import { useSelector, useDispatch } from 'react-redux';
import {
  transportOrderAllFilter,
  transportOrderCanceledFilter,
  transportOrderAcceptedFilter,
  transportOrderLoadedFilter,
  transportOrderCompletedFilter,
  transportOrderPlacedFilter,
  transportOrderLastWeekFilter,
  transportOrderLastMonthFilter,
  transportOrderLastYearFilter,
  transportOrderDeliveredFilter,
} from 'transport-orders-management/filters';
import transportOrderActionTypes from 'transport-orders-management/actionTypes';
import { getForGrid as getForGridTransportOrderManagement } from 'transport-orders-management/actions';
import MenuLink from '../MenuLink';
import MenuSublinkGridFilter from '../MenuSublinkGridFilter';

const propTypes = {
  orderMenuIsOpen: PropTypes.bool.isRequired,
  setOrderMenuIsOpen: PropTypes.func.isRequired,
  handleMenuOpen: PropTypes.func.isRequired,
};

const defaultProps = {};

const commonProps = {
  routePath: '/transport-orders-management',
  stateFilterPath: 'transportOrdersManagement.dataState.filter',
};

function TransportOrderMenuPosition({
  orderMenuIsOpen,
  setOrderMenuIsOpen,
  handleMenuOpen,
}) {
  const dispatch = useDispatch();
  const { placedTransportOrders, deliveredTransportOrders, acceptedForRealizationTransportOrders, loadedTransportOrders } = useSelector(state => state.sideMenu);
  const dataState = useSelector(
    state => state.transportOrdersManagement.dataState,
  );

  const filterChange = filter => {
    dispatch(
      getForGridTransportOrderManagement({
        ...dataState,
        filter,
        skip: 0,
      }),
    );
    dispatch({
      type: transportOrderActionTypes.TRANSPORT_ORDER_MANAGEMENT_SET_FILTER,
      payload: filter,
    });
  };

  const toggleOrderMenu = () => setOrderMenuIsOpen(!orderMenuIsOpen);

  const dispatchAll = () => filterChange(transportOrderAllFilter);
  const dispatchCanceled = () => filterChange(transportOrderCanceledFilter);
  const dispatchAccepted = () => filterChange(transportOrderAcceptedFilter);
  const dispatchLoaded = () => filterChange(transportOrderLoadedFilter);
  const dispatchDelivered = () => filterChange(transportOrderDeliveredFilter);
  const dispatchCompleted = () => filterChange(transportOrderCompletedFilter);
  const dispatchPlaced = () => filterChange(transportOrderPlacedFilter);
  const dispatchLastWeek = () => filterChange(transportOrderLastWeekFilter);
  const dispatchLastMonth = () => filterChange(transportOrderLastMonthFilter);
  const dispatchLastYear = () => filterChange(transportOrderLastYearFilter);

  return (
    <MenuLink
      icon={icons.order}
      label={lang.labels.Orders()}
      handleMenuOpen={handleMenuOpen}
      submenuIsOpen={orderMenuIsOpen}
      handleMenuItemToggle={toggleOrderMenu}
    >
      <MenuSublinkGridFilter
        label={lang.labels.All()}
        onClick={dispatchAll}
        filter={transportOrderAllFilter}
        color="darkGreen"
        {...commonProps}
      />

      <MenuSublinkGridFilter
        label={lang.labels.Canceled()}
        onClick={dispatchCanceled}
        filter={transportOrderCanceledFilter}
        color="orange"
        {...commonProps}
      />

      <MenuSublinkGridFilter
        label={lang.labels.Placed()}
        onClick={dispatchPlaced}
        filter={transportOrderPlacedFilter}
        count={placedTransportOrders}
        color="red"
        {...commonProps}
      />

      <MenuSublinkGridFilter
        label={lang.labels.AcceptedForRealization()}
        onClick={dispatchAccepted}
        filter={transportOrderAcceptedFilter}
        count={acceptedForRealizationTransportOrders}
        color="blue"
        {...commonProps}
      />

      <MenuSublinkGridFilter
        label={lang.labels.Loaded()}
        onClick={dispatchLoaded}
        filter={transportOrderLoadedFilter}
        count={loadedTransportOrders}
        color="customGreen"
        {...commonProps}
      />

      <MenuSublinkGridFilter
        label={lang.labels.Delivered()}
        onClick={dispatchDelivered}
        filter={transportOrderDeliveredFilter}
        count={deliveredTransportOrders}
        color="orange"
        {...commonProps}
      />

      <MenuSublinkGridFilter
        label={lang.labels.Completed()}
        onClick={dispatchCompleted}
        filter={transportOrderCompletedFilter}
        color="green"
        {...commonProps}
      />

      <MenuSublinkGridFilter
        label={lang.labels.LastWeek()}
        onClick={dispatchLastWeek}
        filter={transportOrderLastWeekFilter}
        color="darkGreen"
        {...commonProps}
      />

      <MenuSublinkGridFilter
        label={lang.labels.LastMonth()}
        onClick={dispatchLastMonth}
        filter={transportOrderLastMonthFilter}
        color="darkGreen"
        {...commonProps}
      />

      <MenuSublinkGridFilter
        label={lang.labels.LastYear()}
        onClick={dispatchLastYear}
        filter={transportOrderLastYearFilter}
        color="darkGreen"
        {...commonProps}
      />
    </MenuLink>
  );
}

TransportOrderMenuPosition.propTypes = propTypes;
TransportOrderMenuPosition.defaultProps = defaultProps;

export default memo(TransportOrderMenuPosition);
